"use client"

import moment from "moment"
// import { MdKeyboardArrowDown } from "react-icons/md"
import { useParams } from "react-router-dom"

export default function VisaTab({ propsData }) {
  const { id } = useParams()

  const visaDocuments = Array.isArray(propsData?.documents)
    ? propsData.documents.filter((doc) => doc?.type === "visa")
    : []
  const primaryVisaDocument = visaDocuments[0] || null

  const formData = {
    // customer: id === "new" ? propsData?.firstName + " " + propsData?.lastName : propsData?.fullName || "",
    visaType: propsData?.visaCategory || "",
    institution: propsData?.institution || "",
    term: propsData?.term || "",
    program: propsData?.program || "",
    city: propsData?.cityOfInterest || "",
    country: propsData?.countryOfInterest || "",
    visaStatus: propsData?.visaStatus || "",
    visaExpiryDate: propsData?.visaExpiryDate ? moment(propsData.visaExpiryDate).format("DD/MM/YYYY") : "",
    visaDocName: primaryVisaDocument?.name || propsData?.visaDocName || "",
  }

  // Function to handle document download
  const handleDownload = (index = 0) => {
    if (visaDocuments[index]?.location) {
      window.open(visaDocuments[index].location, "_blank")
    }
  }

  return (
    <div className="bg-[#FFFBF5] border border-[#CAC3BB] p-4 md:p-6 rounded-lg rounded-tl-none text-sm md:text-base">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          {/* <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Invoice Details</label>
            <input
              type="text"
              value={formData.customer}
              readOnly
              className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900"
            />
          </div> */}

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Visa Type</label>
            <input
              type="text"
              value={formData.visaType}
              readOnly
              className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900"
            />
          </div>

          {propsData.visaCategory === "Study Visa" && <> <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Institute</label>
            <div className="relative">
              <input
                type="text"
                value={formData.institution}
                readOnly
                className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 pr-10"
              />
            </div>
          </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Program</label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.program}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 pr-10"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Term</label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.term}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 pr-10"
                />
              </div>
            </div></>}

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">City</label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.city}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 pr-10"
                />
                {/* <MdKeyboardArrowDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" /> */}
              </div>
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Country</label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.country}
                  readOnly
                  className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900 pr-10"
                />
                {/* <MdKeyboardArrowDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" /> */}
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Visa Status</label>
            <input
              type="text"
              value={formData.visaStatus}
              readOnly
              className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Visa Validity (Expiry Date)</label>
            <input
              type="text"
              value={formData.visaExpiryDate}
              readOnly
              className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900"
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Enter Name of Document</label>
            <input
              type="text"
              value={formData.visaDocName}
              readOnly
              className="w-full p-2.5 bg-white border border-gray-200 rounded-md text-gray-900"
            />
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-medium text-gray-700 mb-2">Visa Documents</h3>
            {visaDocuments.length > 0 ? (
              visaDocuments.map((doc, index) => (
                <div key={index} className="flex items-center justify-between">
                  <a
                    href={doc.location}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline break-all"
                  >
                    {doc.name}
                  </a>
                  <button
                    onClick={() => handleDownload(index)}
                    className="px-4 py-1.5 bg-[#005787] text-white text-sm rounded-full hover:bg-[#004a74] transition-colors"
                  >
                    Download
                  </button>
                </div>
              ))
            ) : (
              <span className="text-red-500">
                Visa documents have not been uploaded by the agent yet.
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}